module.exports = __webpack_public_path__ + "img/image (8).69d072ef.webp";